import {useMutation} from "@tanstack/react-query";
import {createRetailLocation} from "../services/RetailLocationService";

export function useRetailLocationCreate() {
    return useMutation({
        mutationFn: createRetailLocation,
    })
}
